var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Label',{attrs:{"icon":"mdi-account"}},[_c('v-text-field',{attrs:{"label":"Name","placeholder":"Enter Name","hide-details":""},model:{value:(_vm.cartOrder.customer.name),callback:function ($$v) {_vm.$set(_vm.cartOrder.customer, "name", $$v)},expression:"cartOrder.customer.name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }